import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function LoginHistory() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/login-history?limit=200").then(({ data }) => setRows(data)); }, []);
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Historique des connexions</h1>
        <p className="text-sm text-[#5C736A]">200 dernières connexions</p>
      </div>
      <div className="ek-card p-0">
        <div className="ek-table-wrap">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Utilisateur</TableHead>
                <TableHead>IP</TableHead>
                <TableHead>Navigateur</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="font-medium">{r.username}</TableCell>
                  <TableCell>{r.ip}</TableCell>
                  <TableCell className="text-xs text-[#5C736A] truncate max-w-xs">{r.user_agent}</TableCell>
                  <TableCell>{new Date(r.at).toLocaleString("fr-FR")}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && (
                <TableRow><TableCell colSpan={4} className="text-center text-sm text-[#5C736A]">Aucun élément.</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
